<template>
    <div class="flex flex-column pl-2 pr-2">

        <div class="mt-2 mb-2 flex align-items-center flex-column md:justify-content-between md:flex-row">
          <h2 class="">SPRÁVY</h2>

          <div class="flex gap-2">
            <PrimevueButton label="Stiahnuť správy" severity="success" icon="pi pi-refresh" text raised class="uppercase" @click="fetchGmailMessages(0)"/>
            
            <!-- Tlačidlo na autorizáciu Google účtu - zobrazí sa len ak je token expirovaný -->
            <PrimevueButton v-if="googleAuthExpired" label="Autorizovat google účet" severity="warning" icon="pi pi-key" text raised class="uppercase" @click="callGoogleAuth()"/>
            
            <!-- Ďalšie možnosti - zakomentované -->
            <!-- <PrimevueButton label="Načítať z Gmailu (1m)" severity="info" icon="pi pi-envelope" text raised class="uppercase" @click="fetchGmailMessages(1)"/> -->
            <!-- <PrimevueButton label="Načítať z Gmailu (3m)" severity="info" icon="pi pi-envelope" text raised class="uppercase" @click="fetchGmailMessages(3)"/> -->
          </div>

        </div>
        <!-- :rowStyle="rowStyle" 
            paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
            :currentPage="pagination.page"
            :rowsPerPageOptions="[200,100,50]"
        -->
        <DataTable
            :rowClass="rowClass"
            lazy paginator :rows="this.pagination.rows"
            @page="onPage"
            :first="this.pagination.first"
            :loading="loading"
            :totalRecords="this.pagination.totalRecords"
            dataKey="id"
            :value="this.messages"
            v-model:filters="filters"
            @filter="onFilter"
            filterDisplay="row" 
            :globalFilterFields="globalFilterFields"
            stripedRows
            row-hover
            scrollable :scrollHeight="`${this.vh - 425}px`"
            :virtualScrollerOptions="{ itemSize: 40 }"
            tableStyle="width: 100%"
            v-model:selection="this.selectedMessage"
            selectionMode="single"
            :metaKeySelection="false"
            @rowSelect="this.selectedMessage.order && this.selectedMessage.order.id > 0 ? openOrderDetail(this.selectedMessage.order.id) : actions(this.selectedMessage)"
        >
          <template #header>
            <div class="flex justify-content-end">
              <IconField iconPosition="left">
                <InputIcon>
                  <i class="pi pi-search mr-2"/>
                </InputIcon>
                <InputText v-model="filters['global'].value" placeholder="Vyhľadať" @keydown.enter="onFilter"/>
                
              </IconField>
            </div>
          </template>
  
           
            <Column field="customerName" header="Zákazník"
                    filterField="customerName"
                    :showFilterMenu="false"
                    :filterMenuStyle="{ width: '8rem' }" style="width: 5%">
                <template #body="slotProps">
                    {{ slotProps.data.customerName }}
                </template>
                <template #filter="{ filterModel, filterCallback }">
                            <InputText v-model="filterModel.value" type="text" @keydown.enter="filterCallback()" class="p-column-filter"
                            placeholder="Hľadať" style="min-width: 10rem"/>
                </template>
            </Column>

            <Column field="subject" header="Predmet"
                    filterField="subject"
                    :showFilterMenu="false"
                    :filterMenuStyle="{ width: '8rem' }" style="width: 15%">
                <template #body="slotProps">
                    {{ slotProps.data.subject }}
                </template>
                <template #filter="{ filterModel, filterCallback }">
                          <InputText v-model="filterModel.value" type="text" @keydown.enter="filterCallback()" class="p-column-filter"
                            placeholder="Hľadať" style="min-width: 10rem"/>
                </template>
            </Column>     

            <Column field="bodyTxt" header="Správa" style="width: 40%" class="overflow-hidden text-overflow-ellipsis">
                <template #body="slotProps">
                    <div class="overflow-ellipsis">
                       {{ slotProps.data.snippet }}
                    </div>
                </template>
                <!--
                    filterField="bodyTxt"
                    :showFilterMenu="false"
                    :filterMenuStyle="{ width: '15rem' }" style="min-width: 15rem"
                    <template #filter="{ filterModel, filterCallback }">
                          <InputText v-model="filterModel.value" type="text" @input="filterCallback()" class="p-column-filter"
                            placeholder="Hľadať" style="min-width: 10rem"/>
                    </template>
                -->
            </Column> 

            <Column 
                    field="orderNumber" header="Objednávka"
                    filterField="orderNumber"
                    :showFilterMenu="false"
                    :filterMenuStyle="{ width: '6rem' }" style="width: 12%">
                <template #body="slotProps">
                    {{ slotProps.data.orderNumber }}
                </template>
                <template #filter="{ filterModel, filterCallback }">
                          <InputText v-model="filterModel.value" type="text" @keydown.enter="filterCallback()" class="p-column-filter"
                          placeholder="Hľadať" style="min-width: 6rem"/>
                </template>
            </Column>      

            <Column header="Dátum" style="width: 20%">
                <template #body="slotProps">
                  {{ Utils.parseToSlovakDateTime(slotProps.data.createdAt) }}
                </template>
              </Column>
            
            <Column header="" >
                <template #body="slotProps">
                    <PrimevueButton v-tooltip.top="{ value: 'Akcie so správou' }" type="button" icon="pi pi-ellipsis-v" @click="actions(slotProps.data)" text size="small"/>
                </template>
            </Column>

        </DataTable>
        
        <PrimevueDialog v-model:visible="visibleActions" @hide="hideModal()" modal header="Správa" style="width: 50rem;position: relative;">
                        
          <PrimevuePanel header="Akcie so správou" class="mt-2 mb-2 border-solid border-1 surface-border">
              <form @submit.prevent="submitActions" name="actionsForm">

                <div class="grid">
                  <div class="col-10"> 

                      <div class="field grid">
                          <label for="ignored" class="col-4">Ignorovať emailovu adresu</label>
                          <div class="col-8">
                            <PrimevueCheckbox v-model="this.ignoredEmail" inputId="ignored" name="ignored" :binary="true" />
                          </div>

                      </div>
                      <div class="field grid">
                        <label for="mark" class="col-4">Označiť správu značkou</label>
                        <div class="col-8">
                          <PrimevueSelect
                              id="mark"
                              v-model="this.mark"
                              :options="this.store.marks"
                              optionLabel="name"
                              class="w-full"
                              :placeholder="this.mark.name"
                              
                          />
                        </div>
                      </div>
                      <div class="field grid">
                        <label for="order" class="col-4">Priradiť objednávku</label>
                        <div class="col-8">
                          <PrimevueButton @click="this.visibleSelect = !this.visibleSelect" label="test" class="flex justify-content-between w-full min-h-1rem" outlined >
                              <span >
                              <span v-if="this.order.id > 0">
                                <span >{{this.order.orderCode}}</span> *
                                <span >{{this.order.customer.lastName}}</span> *
                                <span >{{this.order.customer.city}}</span>
                              </span>
                              </span>
                              <span class="flex justify-content-center align-items-center" style="width: 1.8rem;">
                                <svg width="14" height="14" viewBox="0 0 14 14" 
                                      fill="none" xmlns="http://www.w3.org/2000/svg" class="p-icon p-button-icon">
                                      <path d="M7.01744 10.398C6.91269 10.3985 6.8089 10.378 6.71215 10.3379C6.61541 10.2977 6.52766 10.2386 6.45405 10.1641L1.13907 4.84913C1.03306 4.69404 0.985221 4.5065 1.00399 4.31958C1.02276 4.13266 1.10693 3.95838 1.24166 3.82747C1.37639 3.69655 1.55301 3.61742 1.74039 3.60402C1.92777 3.59062 2.11386 3.64382 2.26584 3.75424L7.01744 8.47394L11.769 3.75424C11.9189 3.65709 12.097 3.61306 12.2748 3.62921C12.4527 3.64535 12.6199 3.72073 12.7498 3.84328C12.8797 3.96582 12.9647 4.12842 12.9912 4.30502C13.0177 4.48162 12.9841 4.662 12.8958 4.81724L7.58083 10.1322C7.50996 10.2125 7.42344 10.2775 7.32656 10.3232C7.22968 10.3689 7.12449 10.3944 7.01744 10.398Z" fill="currentColor"></path>
                                </svg>
                              </span>

                          </PrimevueButton>
                        </div>

                      </div>
                    </div>
                    <div class="col-2 flex flex-wrap align-items-center justify-content-center">
                      <PrimevueButton type="submit" v-tooltip.top="{ value: 'Uloženie nastavení' }" icon="pi pi-save" 
                                      size="large" severity="success" aria-label="Save"
                                      class="h-3rem"/>
                      <!--<PrimevueButton @click="visibleActions = false" label="Zrušiť" severity="danger" text raised class="uppercase"/>
                        label="Použiť" text raised class="uppercase" -->
                    </div>
                </div>
              </form>
          </PrimevuePanel>
          

          <DetailMessage :message="this.selectMessage" :internal="false"></DetailMessage>

          
          <div v-if="this.visibleSelect" class="card" 
               style="z-index: 10; position: absolute; top: 245px; left: 239px; min-width: 31rem; transform-origin: center top; margin-top: 2px;">
 
               <div class="ml-1 mt-1 flex justify-content-start">
                <IconField iconPosition="left">
                  <InputIcon>
                    <i class="pi pi-search mr-2"/>
                  </InputIcon>
                  <InputText v-model="orderFilters['global'].value" placeholder="Vyhľadať" @input="onOrderFilter" class="w-20rem"/>
                </IconField>
              </div>
              <DataTable
                  
                  lazy paginator :rows="this.selectParams.rows"
                  @page="onOrderPage"
                  :first="this.selectParams.first"
                  :loading="this.selectLoading"
                  :totalRecords="this.selectParams.totalRecords"
                  dataKey="id"
                  :value="this.orderOptions"
                 
                  stripedRows
                  row-hover
                  scrollable
                  v-model:selection="this.selectedOrder"
                  selectionMode="single"
                  :metaKeySelection="false"
                  @rowSelect="selectOrder(this.selectedOrder)"
                  size="small"
              >
                  <Column header="ID" field="orderCode" style="width: 5%">
                  </Column>
                  <Column header="Meno" field="customer.lastName" style="width: 50%">
                  </Column>    
                  <Column header="Obec" field="customer.city" style="width: 45%">
                  </Column>              
              </DataTable>              
          </div>
        </PrimevueDialog>

        <!-- Loading dialog pre načítavanie Gmail správ -->
        <PrimevueDialog v-model:visible="gmailLoading" modal :closable="false" :draggable="false" :style="{ width: '25rem' }">
          <div class="flex flex-column align-items-center gap-3">
            <ProgressSpinner style="width: 50px; height: 50px" strokeWidth="4" />
            <div class="text-center">
              <h3>Načítavanie správ z Gmailu...</h3>
              <p class="text-sm text-600 mt-2">Proces môže trvať 2-3 minúty. Prosím počkajte.</p>
            </div>
          </div>
        </PrimevueDialog>
    </div>
  
</template>

<script lang="ts">

//import PrimevueTag from 'primevue/tag';
import {store} from "@/components/store";
import Security from "@/components/security";
import DataTable from "primevue/datatable";
import Column from "primevue/column";
import router from "@/router";
import {FilterMatchMode} from "primevue/api";
import PrimevueSelect from "primevue/dropdown";
import IconField from 'primevue/iconfield';
import InputIcon from "primevue/inputicon";
import notie from "notie/dist/notie";
import PrimevueButton from "primevue/button";
import PrimevueDialog from "primevue/dialog";
import PrimevuePanel from 'primevue/panel';
import PrimevueCheckbox from 'primevue/checkbox';
import ProgressSpinner from 'primevue/progressspinner';
import Utils from '@/components/utils';
import {emiter} from '../main';
import DetailMessage from '@/components/DetailMessage.vue';


export default {
  components: {
    DataTable,
    Column,
    PrimevueDialog,
    PrimevueSelect,
    IconField,
    InputIcon,
    PrimevueButton,
    PrimevueCheckbox,
    PrimevuePanel,
    ProgressSpinner,
    DetailMessage
  },
  name: "MessageList",
  data() {
    return {
      googleAuthExpired: false,
      store,
      vh: 0,
      visibleActions: false,
      ignoredEmail: false,
      markRead: false,
      mark:  {id: 0, name:"" },
      order: {id: 0},
      orderOptions: [],
      selectedOrder: null,
      selectMessage: null,
      selectedMessage: null,
      isSelectFilter: false,
      visibleSelect: false,
      routeByType: String,
      messages: [],
      filters: {
        global: {value: null, matchMode: FilterMatchMode.CONTAINS},
        orderNumber: {value: null, matchMode: FilterMatchMode.CONTAINS},
        customerName: {value: null, matchMode: FilterMatchMode.CONTAINS},
        subject: {value: null, matchMode: FilterMatchMode.CONTAINS},
      },
      filterFields: [  {field: 'OrderId__OrderCode',value: ""},
                       {field: 'CustomerId__LastName',value: ""},
                       {field: 'Subject',value: ""}
                    ],
      globalFilterFields: ['OrderId__OrderCode', 'CustomerId__LastName','Subject'],
      loading: false,
      selectLoading: false,
      gmailLoading: false,
      routeParams: null,
      pagination: {
        first: 0,
        rows: 50,
        totalRecords: 0, // Total number of records for pagination
        filters: {table : "message"},
      },
      orderFilters : {
          global: {value: null, matchMode: FilterMatchMode.CONTAINS},
      },
      selectParams: {
        first: 0,
        rows: 8,
        totalRecords: 0,
        filters:{global: "",
                 table:"order",
                 globalFilterFields: ['OrderCode', 'CustomerId__LastName','CustomerId__City']
                },

      },
    }
  },
  computed: {
    Utils() {
      return Utils
    },
  },
  
  beforeMount() {
    if (Security.requireToken()){
      store.selectModul = this.$route.path.split("/")[1]
      this.setDynamicHeight(); 
      // Aktualizácia výšky pri zmene veľkosti okna
      window.addEventListener("resize", this.setDynamicHeight);

      this.routeParams = this.$route.params
      this.initFilters()
      this.loadComponent()
      emiter.on('reload',this.loadComponent)
      
      // Check if we're returning from OAuth callback
      const urlParams = new URLSearchParams(window.location.search);
      const googleParam = urlParams.get('google');
      if (googleParam === 'ok') {
        notie.alert({
          type: 'success',
          text: 'Google autorizácia úspešná',
          position: "top"
        });
        // Clean up URL
        window.history.replaceState({}, document.title, window.location.pathname);
      } else if (googleParam === 'error') {
        const msg = urlParams.get('msg') || 'neznáma chyba';
        notie.alert({
          type: 'error',
          text: `Google autorizácia zlyhala: ${msg}`,
          position: "top"
        });
        // Clean up URL
        window.history.replaceState({}, document.title, window.location.pathname);
      }
      
      // Skontrolovať stav Google autorizácie pri načítaní stránky
      this.checkGoogleAuthStatus()
    }
  },
  
    beforeUnmount(){
      emiter.off('reload',this.loadComponent);
      window.removeEventListener("resize", this.setDynamicHeight);
    },  
    
    beforeRouteUpdate(to, from, next) {
        if (Security.requireToken()){
        this.routeParams = to.params
        this.initFilters()
        this.loadComponent()
        emiter.on('reload',this.loadComponent)
      
        next()
      }
    },
   
    methods: {

      setDynamicHeight() {
        this.vh = window.innerHeight; // Nastavenie viditeľnej výšky
      },

      hideModal(){
        this.selectedMessage = null
        console.log("HIde modal");
      },

      openOrderDetail(orderId: number){
        router.push('/mod-orders/order/' + String(orderId))
      },

      selectOrder(order){
        this.order = order
        this.visibleSelect = false
      },

      submitActions(){
        //console.log("Submit");
        if(this.mark.id > 0){
          let markObj = this.store.marks.filter(obj => obj.id == this.mark.id)[0];
          this.selectMessage.mark = markObj;
          this.selectMessage.assigned = true
          this.selectMessage.unread = true
        }else{
          this.selectMessage.mark = null
        }
        if(this.order.id > 0){
          let orderObj = this.orderOptions.filter(obj => obj.id == this.order.id)[0];   
          this.selectMessage.order = orderObj;
          this.selectMessage.customer = orderObj.customer
          this.selectMessage.assigned = true
          this.selectMessage.unread = true

        }else{
          this.selectMessage.order = null
          this.selectMessage.customer = null
        }

        if(this.ignoredEmail){
            
            this.selectMessage.deleted = true
            this.selectMessage.deletedAt = new Date()
            
            let ignoredEmail =  {
                id: 0,
                email: this.selectMessage.fromEmail
              }

            fetch(store.Api_url + "/v1/ignored-email", Security.requestOptions("POST",ignoredEmail))
            .then((response) => response.json())
            .then((responseData) => {
              if (responseData.error) {

                //this.$emit('error', responseData.message);
                notie.alert({
                  type: 'error',
                  text: "Nepodarilo pridať tento email k ignorovaným emailom"
                })
              } else {

                notie.alert({
                  type: 'success',
                  text: "Tento email bol úspešne pridaný k ignorovaným emailom",
                  position: "bottom"
                })
              }
            })
            .catch((error) => {
              //alert('chyba pri nacitani objednavok: ' + error)
              notie.alert({
                  type: 'error',
                  text: "Nastala chyba pri pridaní emailu k ignorovaným emailom: "+error
                })             
            })
        }
        if(this.markRead){

            this.selectMessage.deleted = true
            this.selectMessage.deletedAt = new Date()

            let ignoredEmail =  {
                id: 0,
                email: this.selectMessage.fromEmail
              }

            fetch(store.Api_url + "/v1/ignored-email", Security.requestOptions("POST",ignoredEmail))
            .then((response) => response.json())
            .then((responseData) => {
              if (responseData.error) {

                //this.$emit('error', responseData.message);
                notie.alert({
                  type: 'error',
                  text: "Nepodarilo pridať tento email k ignorovaným emailom"
                })
              } else {

                notie.alert({
                  type: 'success',
                  text: "Tento email bol úspešne pridaný k ignorovaným emailom",
                  position: "bottom"
                })
              }
            })
            .catch((error) => {
              //alert('chyba pri nacitani objednavok: ' + error)
              notie.alert({
                  type: 'error',
                  text: "Nastala chyba pri pridaní emailu k ignorovaným emailom: "+error
                })
            })
        }

        fetch(store.Api_url + "/v1/message/" + this.selectMessage.id, Security.requestOptions("PUT", this.selectMessage))
          .then((response) => response.json())
          .then((responseData) => {
            if (responseData.error) {

              //this.$emit('error', responseData.data.message);
              notie.alert({
                type: 'error',
                text: responseData.data.message
              })
            } else {
              notie.alert({
                type: 'success',
                text: "Údaje pre správu boli použité"
              })
              
              emiter.emit('reload');

            }
          })
          .catch((error) => {
            //this.$emit('error', "Chyba pri uložení údajov" + error);
            notie.alert({
              type: 'error',
              text: "Chyba pri uložení údajov" + error
            })
          })
          //.finally(() => {    
          //  this.selectMessage = null
          //})
          
        //this.selectMessage = null

      },

      actions(dataMessage){
        this.visibleActions = true
        this.visibleSelect = false
        this.ignoredEmail = false

        this.initSelectFilters()
        //console.log("DataMessage:", dataMessage);
        if(dataMessage.mark){
          this.mark = dataMessage.mark;
        }else{
          this.mark = {id: 0, name: ""}
        }

        console.log("dataMessage:", dataMessage);

        if(dataMessage.order && dataMessage.order.id > 0){
          console.log("actions Order:", dataMessage.order);
          this.order = dataMessage.order
            this.order.customer.lastName = dataMessage.customer.lastName
            this.order.customer.city = dataMessage.customer.city

            this.orderOptions = [{orderCode: dataMessage.order.orderCode, 
                                  customer: {lastName: dataMessage.customer.lastName, city: dataMessage.customer.city}}]

        }else{

          this.order = {id: 0} //{orderCode : "", customer: {lastName: "", city:""}}
          this.loadLazyDataOrders(this.selectParams)
        }

        this.selectMessage = dataMessage
       
      },
  
      rowClass(data) {
            return [{ 'font-bold': data.unread }];
      },

      onPage(event) {
        this.pagination.first = event.first; // PrimeVue page is zero-based; adjust if your API is 1-based

        this.loadLazyData(this.routeByType,this.pagination);
      },
      onFilter(event) {
        if(event.filters){
           //this.pagination.filters = event.filters;
           this.pagination.filters.filterFields = [ {field: 'OrderId__OrderCode',value: event.filters.orderNumber.value ? event.filters.orderNumber.value : ""},
                                                    {field: 'CustomerId__LastName',value: event.filters.customerName.value ? event.filters.customerName.value: ""},
                                                    {field: 'Subject',value: event.filters.subject.value ? event.filters.subject.value : ""}
                                                  ];
           this.pagination.filters.global = event.filters.global.value                                        
        }else{
          this.pagination.filters.filterFields = this.filterFields
          this.pagination.filters.global = this.filters.global.value
        }
        this.pagination.filters.globalFilterFields = this.globalFilterFields;
        this.pagination.first = 0;  // Reset to the first page
        //console.log("Filters:", this.pagination.filters);
        this.loadLazyData(this.routeByType,this.pagination);
      },
      
      onOrderPage(event) {
        this.selectParams.first = event.first; // PrimeVue page is zero-based; adjust if your API is 1-based

        this.loadLazyDataOrders(this.selectParams)
      },
      
      onOrderFilter() {
        this.selectParams.filters.global = this.orderFilters.global.value
        this.selectParams.first = 0
        
        if(this.selectParams.filters.global.length > 2){
           this.loadLazyDataOrders(this.selectParams)
          }
        
      },

      initFilters(){
        this.pagination.filters.filterFields = this.filterFields
        this.pagination.filters.global = ""
        this.pagination.filters.globalFilterFields = this.globalFilterFields;
        this.filters = {
          global: {value: null, matchMode: FilterMatchMode.CONTAINS},
          orderNumber: {value: null, matchMode: FilterMatchMode.CONTAINS},
          customerName: {value: null, matchMode: FilterMatchMode.CONTAINS},
          subject: {value: null, matchMode: FilterMatchMode.CONTAINS},
        }
      },
      initSelectFilters(){
        this.selectParams.first = 0
        this.selectParams.rows = 7
        this.selectParams.filters.global = ""
        this.orderfilters = {
            global: {value: null, matchMode: FilterMatchMode.CONTAINS},

        }
      },
      loadComponent(){
        //Security.requireToken();
        if(store.token != ""){
          this.pagination.first = 0
          this.pagination.totalRecords = 0

          //console.log('Load component',this.pagination.filters);
          this.routeByType = Utils.getMessageRoute(this.store.basicUrlFilterMessages,this.routeParams)
          
          this.loadLazyData(this.routeByType,this.pagination)
        }
      },
      loadLazyDataOrders(params) {
        this.selectLoading = true;
        console.log('loading order list')

        let queryParams = `&limit=${params.rows}&offset=${(params.first)}`;

        fetch(`${store.Api_url}${this.store.basicUrlFilterOrders}${queryParams}`, Security.requestOptions("POST",params.filters))
        .then((response) => response.json())
        .then((responseData) => {
          if (!responseData.error) {
            //console.log("Orders:", responseData);
            this.orderOptions = responseData.data
            if(this.orderOptions){
            // Corrected forEach usage
              this.orderOptions.forEach((order) => {
                order.label = (order.customer.lastName).padEnd(20) + " * " + order.customer.city.padEnd(20) + " * " + order.orderCode
              });
            }else{
              this.orderOptions = []
            }
            //console.log('Order Options',this.orderOptions);
            this.selectParams.totalRecords = responseData.totalRecords
            this.selectLoading = false;
          }
        })
        .catch((error) => {
          this.orderOptions = []
          this.selectLoading = false;
        })
      },

      loadLazyData(routeByType,params) {
        this.loading = true;

        let queryParams = `&limit=${params.rows}&offset=${(params.first)}`;

        fetch(`${store.Api_url}${routeByType}${queryParams}`, Security.requestOptions("POST",params.filters))
            .then(response => response.json())
            .then(responseData => {
              if (responseData.error) {
                console.error("error:", responseData.message);
                //this.$emit('error', responseData.message);
                notie.alert({
                    type: 'error',
                    text: "Zoznam správ sa nepodarilo načítať " + responseData.message,
                    position: "top"
                  })            
              } else {
                 //console.log("Messages:", responseData);
                  this.messages = responseData.data
                  
                  if(responseData.data){
                  // Corrected forEach usage
                    this.messages.forEach((message) => {
                        if(message.customer){
                            if(message.customer.lastName){
                                    message.customerName =  message.customer.lastName + " " + message.customer.firstName
                                }else{
                                    message.customerName = message.customer.lastName
                                }
                            }else{
                                message.customerName = "" 
                        }
                        if(message.order){
                            message.orderNumber = message.order.orderCode
                        }else{
                            message.orderNumber = ""
                        }
                    });
                  }else{
                    notie.alert({
                    type: 'error',
                    text: "Zoznam správ je prázdny",
                    position: "top"
                  })
                  }
                  this.pagination.totalRecords = responseData.totalRecords
                  this.loading = false
              }
            })
            .catch(error => {
              //alert('Error fetching data: ' + error);
              notie.alert({
                    type: 'error',
                    text: "Chyba pri načítaní správ: "+error,
                    position: "top"
                  })
              this.loading = false;
            });
      },
      callGoogleAuth(){
        // Full-page redirect to OAuth start endpoint
        // This is more reliable than popup windows and handles cookies/sessions properly
        window.location.href = `${store.Api_url}/google/oauth/start`;
      },
      checkGoogleAuthStatus(){
        // Check OAuth status from the new status endpoint
        fetch(`${store.Api_url}/google/oauth/status`, Security.requestOptions("GET"))
            .then(response => response.json())
            .then(responseData => {
              if (responseData.Error) {
                this.googleAuthExpired = true;
              } else {
                if(responseData.TokenValid === false){
                  this.googleAuthExpired = true;
                }else{
                  this.googleAuthExpired = false;
                }
              }
            })
            .catch(error => {
              console.error("Error checking Google auth status:", error);
              this.googleAuthExpired = true;
            });
      },
      fetchGmailMessages(months){
        // Najprv skontrolovať stav tokenu pred začatím načítavania
        fetch(`${store.Api_url}/google/oauth/status`, Security.requestOptions("GET"))
          .then(response => response.json())
          .then(statusData => {
            if (!statusData.TokenValid) {
              this.googleAuthExpired = true;
              this.gmailLoading = false;
              notie.alert({
                type: 'warning',
                text: 'Pre stiahnutie správ je potrebné autorizovať Google účet. Kliknite na "Autorizovat google účet".',
                position: "top"
              });
              return;
            }
            
            // Token je platný, pokračovať so stiahnutím správ
            this.gmailLoading = true;
            let queryParams = `/fetch/gmail/${months}`;
            return this.performGmailFetch(queryParams);
          })
          .catch(error => {
            console.error("Error checking token status:", error);
            // V prípade chyby pri kontrole, pokračovať s pokusom o stiahnutie
            // API vrátí správnu chybovú správu, ak token nie je platný
            this.gmailLoading = true;
            let queryParams = `/fetch/gmail/${months}`;
            return this.performGmailFetch(queryParams);
          });
      },
      performGmailFetch(queryParams){

        return fetch(`${store.Api_url}${queryParams}`, Security.requestOptions("GET"))
            .then(response => {
              // Vždy skúsiť parsovať JSON, aj keď status nie je OK
              return response.json().then(data => {
                if (!response.ok) {
                  // Ak je to error response, vrátiť ho s error flagom
                  throw { ...data, status: response.status };
                }
                return data;
              });
            })
            .then(responseData => {
              this.gmailLoading = false;
              
              // Kontrola, či to nie je error response
              if (responseData.error) {
                notie.alert({
                  type: 'error',
                  text: responseData.message || "Chyba pri načítaní správ z Gmailu",
                  position: "top"
                });
                // Ak je to unauthorized error, aktualizovať stav
                if (responseData.message && responseData.message.includes('OAuth token')) {
                  this.googleAuthExpired = true;
                }
                return;
              }
              
              if (Array.isArray(responseData)) {
                notie.alert({
                  type: 'success',
                  text: `Načítaných ${responseData.length} správ z Gmailu. Zoznam sa obnoví.`,
                  position: "top"
                });
                
                // Automaticky obnoviť zoznam správ po krátkom čakaní
                setTimeout(() => {
                  this.loadComponent();
                }, 1000);
              } else {
                notie.alert({
                  type: 'success',
                  text: "Načítanie správ dokončené. Zoznam sa obnoví.",
                  position: "top"
                });
                
                // Obnoviť zoznam správ
                setTimeout(() => {
                  this.loadComponent();
                }, 1000);
              }
            })
            .catch(error => {
              this.gmailLoading = false;
              console.error("Error fetching Gmail messages:", error);
              
              // Ak je chyba 401 (Unauthorized) alebo obsahuje OAuth token error, aktualizovať stav
              if (error.status === 401 || (error.message && error.message.includes('OAuth token'))) {
                this.googleAuthExpired = true;
                this.checkGoogleAuthStatus();
              }
              
              const errorMessage = error.message || error.details || "Neznáma chyba";
              notie.alert({
                type: 'error',
                text: "Chyba pri načítaní správ z Gmailu: " + errorMessage,
                position: "top"
              });
            });
      }
    }
}
</script>
<style scoped>


</style>